import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JornayaService {
  loaded: boolean = false;
  loadedAt: number = null;

  constructor() {
    this.watchForLoaded();
  }

  isLoaded(): boolean {
    if (this.loaded === false) {
      this.loaded = typeof window['LeadiD'] === 'object' && typeof window['LeadiD'].snap === 'function';
    }
    return this.loaded
  }

  watchForLoaded() {
    if (this.loaded === false) {
      setTimeout(function() {
        if (this.isLoaded() === true) {
          this.loadedAt = Date.now();
        } else {
          this.watchForLoaded();
        }
      }.bind(this), 1000);
    }
  }

  /* used for email-verification, not rates-form */
  secondsSinceLoaded():number {
    if (this.loadedAt === null) {
      return null;
    }

    let t = (Date.now() - this.loadedAt) / 1000;

    return Math.floor(t);
  }

  snap() {
    if (this.isLoaded()) {
      window['LeadiD'].snap();
    }
  }
}
